import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative w-full min-h-screen bg-black overflow-hidden flex flex-col justify-between py-20" data-id="element-196">
      {/* Text Content - Top Section */}
      <div className="relative z-10 pt-20 pb-12 px-4 sm:px-6 lg:px-8" data-id="element-197">
        <div className="max-w-7xl mx-auto text-center" data-id="element-198">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-199">
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-6 leading-tight tracking-tight" data-id="element-200">
              COMUNICACIÓN
              <br data-id="element-201" />
              <span className="text-[#C9A961]" data-id="element-202">MAGNÉTICA</span>
            </h1>

            <p className="text-2xl md:text-3xl text-gray-300 mb-8 font-light" data-id="element-203">
              Habla, convence y lidera.
            </p>
          </motion.div>
        </div>
      </div>

      {/* Book Cover Image - Bottom Section, Centered */}
      <div className="relative z-10 flex-1 flex items-center justify-center px-4 pb-12" data-id="element-204">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9,
        y: 50
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.3,
        ease: 'easeOut'
      }} className="relative max-w-md w-full" data-id="element-205">
          {/* Glow effect behind book */}
          <div className="absolute inset-0 bg-[#C9A961]/20 blur-[80px] scale-110" data-id="element-206" />

          {/* Book Cover */}
          <img src="https://cdn.magicpatterns.com/uploads/3roP78wC5T4ePwrj5adkFD/portada_libro_principal.png" alt="Comunicación Magnética - Portada del Ebook" className="relative w-full h-auto drop-shadow-2xl transform hover:scale-105 transition-transform duration-500" data-id="element-207" />
        </motion.div>
      </div>

      {/* Subtle vignette effect */}
      <div className="absolute inset-0 bg-gradient-radial from-transparent via-black/50 to-black pointer-events-none" data-id="element-208" />
    </section>;
}